module.exports = __webpack_public_path__ + "public/adminIcons/last24hrsusers.svg?d611bc10";